import gql from 'graphql-tag';

const AdLineageQCNotesQuery = gql`
  query($adId: String!) {
    adQc: adQcByAdId(adId: $adId) {
      adId
      qc1
      qc1Username
      qc2
      modifiedDate
    }
    adLineage: adLineageByAdId(adId: $adId) {
      adId
      accountId
      campaignId
      adsetId
      adName
      month
      year
      createdAt
      username
      parentAdId
      up6Vehicles
      serviceTarget
      corporateTarget
      oemFocus
      clientRq
      timer
      modifiedDate
      modefiedBy
      buildBy
      organicPostId
      isOrganic
      coop
      parentCategory
      parentPackage
      parentLanguage
      parentEvent
      adFormat
      parentGroup
      parentDealer
    }
    adNotes: allAdNotes(
      orderBy: CREATED_DATE_DESC
      condition: { adId: $adId }
    ) {
      nodes {
        noteId
        adId
        noteText
        username
        createdDate
      }
    }
  }
`;

const AdLineageByAdIdQuery = gql`
  query($adId: String!) {
    adLineage: adLineageByAdId(adId: $adId) {
      adId
      accountId
      campaignId
      adsetId
      adName
      month
      year
      createdAt
      username
      parentAdId
      up6Vehicles
      serviceTarget
      corporateTarget
      oemFocus
      clientRq
      timer
      modifiedDate
      modefiedBy
      buildBy
      qc1
      qc2
      notesBy
      organicPostId
      isOrganic
      coop
      parentCategory
      parentPackage
      parentLanguage
      parentEvent
      adFormat
      parentGroup
      parentDealer
      notes
    }
  }
`;

const AdLineageByParentAdIdQuery = gql`
  query($parentAdId: String!) {
    adLineage: allAdLineages(condition: { parentAdId: $parentAdId }) {
      nodes {
        adId
        accountId
        campaignId
        adsetId
        adName
        month
        year
        createdAt
        username
        parentAdId
        up6Vehicles
        serviceTarget
        corporateTarget
        oemFocus
        clientRq
        timer
        modifiedDate
        modefiedBy
        buildBy
        qc1
        qc2
        notesBy
        organicPostId
        isOrganic
        coop
        parentCategory
        parentPackage
        parentLanguage
        parentEvent
        adFormat
        parentGroup
        parentDealer
        notes
      }
    }
  }
`;

const InsertAdLineageQuery = gql`
  mutation($ad_lineage: CreateAdLineageInput!) {
    createAdLineage(input: $ad_lineage) {
      adLineage {
        adId
        accountId
        campaignId
        adsetId
        adName
        month
        year
        createdAt
        username
        parentAdId
        up6Vehicles
        serviceTarget
        corporateTarget
        oemFocus
        clientRq
        timer
        modifiedDate
        modefiedBy
        buildBy
        qc1
        qc2
        notesBy
        organicPostId
        isOrganic
        coop
        parentCategory
        parentPackage
        parentLanguage
        parentEvent
        adFormat
        parentGroup
        parentDealer
        notes
      }
    }
  }
`;

const UpdateAdLineageQuery = gql`
  mutation($ad_lineage: UpdateAdLineageByAdIdInput!) {
    updateAdLineageByAdId(input: $ad_lineage) {
      adLineage {
        accountId
        campaignId
        adsetId
        adName
        month
        year
        createdAt
        username
        parentAdId
        up6Vehicles
        serviceTarget
        corporateTarget
        oemFocus
        clientRq
        timer
        modifiedDate
        modefiedBy
        buildBy
        qc1
        qc2
        notesBy
        organicPostId
        isOrganic
        coop
        parentCategory
        parentPackage
        parentLanguage
        parentEvent
        adFormat
        parentGroup
        parentDealer
        notes
      }
    }
  }
`;

export async function getAdLineageQcNotes(adId) {
  const client = window.__APOLLO_CLIENT__;
  const queryResult = await client.query({
    query: AdLineageQCNotesQuery,
    variables: { adId }
  });
  return {
    ...queryResult.data,
    adNotes: queryResult.data.adNotes.nodes
  };
}

export async function getAdLineageByAdId(adId) {
  const client = window.__APOLLO_CLIENT__;
  const queryResult = await client.query({
    query: AdLineageByAdIdQuery,
    variables: { adId }
  });
  return queryResult.data.adLineage;
}

export async function getAdLineageByParentAdId(parentAdId) {
  const client = window.__APOLLO_CLIENT__;
  const queryResult = await client.query({
    query: AdLineageByParentAdIdQuery,
    variables: { parentAdId }
  });
  return queryResult.data.adLineage.nodes;
}

export async function insertAdLineage(adLineageInfo) {
  const client = window.__APOLLO_CLIENT__;
  const insertResult = await client.mutate({
    mutation: InsertAdLineageQuery,
    variables: { ad_lineage: { adLineage: adLineageInfo } }
  });
  return insertResult.data.createAdLineage.adLineage;
}

export async function updateAdLineage(adLineageInfo, adId) {
  const client = window.__APOLLO_CLIENT__;
  await client.mutate({
    mutation: UpdateAdLineageQuery,
    variables: { ad_lineage: { adLineagePatch: adLineageInfo, adId } }
  });
  client.resetStore();
}



// WEBPACK FOOTER //
// ./src/utils/ad.lineage.js